import React, { useEffect, useState, useMemo } from 'react';
import Modal from 'react-modal';
import AdSense from 'react-adsense';
import { ClipLoader } from 'react-spinners';
import Language_i18 from '../js/useNationalLanguage.jsx';

Modal.setAppElement('#root');

function AdModal({ isOpen, onClose }) {
  const { i18n, lang } = Language_i18();

  const translations = {
    vi: {
      closeAfter: 'Đóng quảng cáo sau',
      closeAd: 'Đóng quảng cáo'
    },
    en: {
      closeAfter: 'Close ad in',
      closeAd: 'Close ad'
    }
  };

  const showBanner = useMemo(() => Math.random() < 0.5, []);

  const [modalStyle, setModalStyle] = useState({});
  const [shouldShowAd, setShouldShowAd] = useState(false);
  const [countdown, setCountdown] = useState(5);

  const fixModalPosition = () => {
    const baseStyle = {
      height: '70%',
      top: '15%',
      width: 'auto'
    };

    if (window.innerWidth >= 1200) {
      setModalStyle({
        ...baseStyle,
        right: '40px',
        left: '300px'
      });
    } else {
      setModalStyle({
        ...baseStyle,
        right: '10px',
        left: '10px'
      });
    }
  };

  useEffect(() => {
    fixModalPosition();

    const showTimer = setTimeout(() => {
      setShouldShowAd(true);
    }, 500);

    return () => clearTimeout(showTimer);
  }, []);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [countdown]);

  return (
    <Modal
      isOpen={isOpen}
      // onRequestClose={onClose}
      contentLabel="Advertisement"
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.18)',
          zIndex: 99999
        },

        content: {
          ...modalStyle,
          position: 'fixed',
          zIndex: 100000,
          overflow: 'auto',
          background: '#ffffff',
          border: '1px solid #d1d5db',
          borderRadius: '12px',
          boxShadow: '0 12px 40px rgba(0, 0, 0, 0.3)'
        }
      }}
    >
      <div className="cards">
        {shouldShowAd ? (
          <>
            {showBanner ? (
              // <div className="w-full flex justify-center">
              //   <a
              //     href="https://premium69.click/"
              //     target="_blank"
              //     rel="noopener noreferrer"
              //     className="block w-full max-w-xl mx-auto overflow-hidden rounded-2xl"
              //   >
              //     <img
              //       src="https://hust.media/img/videos/banner.gif"
              //       alt="HUST Media Banner"
              //       className="w-full h-auto object-cover"
              //     />
              //   </a>
              // </div>

              <AdSense.Google
                client="ca-pub-4574266110812955"
                slot="3259681051"
                style={{ display: 'block' }}
                responsive="true"
              />
            ) : (
              <AdSense.Google
                client="ca-pub-4574266110812955"
                slot="3259681051"
                style={{ display: 'block' }}
                responsive="true"
              />
            )}

            <div className="flex justify-between items-center py-0 pr-0">
              {countdown > 0 ? (
                <div className="ml-auto text-sm text-gray-600">
                  {translations[lang]?.closeAfter}{' '}
                  {countdown}{' '}
                  {lang === 'vi' ? 'giây' : 's'}
                </div>
              ) : (
                <button
                  type="button"
                  className="ml-auto text-sm bg-pink-200 text-gray-600 px-2 py-1 rounded-md hover:bg-pink-300 focus:outline-none"
                  onClick={onClose}
                >
                  {translations[lang]?.closeAd}
                </button>
              )}
            </div>
          </>
        ) : (
          <div className="flex justify-center my-4">
            <ClipLoader size={90} />
          </div>
        )}
      </div>
    </Modal>
  );
}

export default AdModal;